import React from "react";
import styled from "styled-components";

export interface KindlyNoteProps {
  title: string;
  list: string[];
}
const KindlyNote: React.FC<KindlyNoteProps> = ({ list, title }) => {
  return (
    <NoteContainer>
      <p style={{ color: "#0E0E0E" }}>{title}</p>
      <ul>
        {list.map((listItem) => (
          <li key={listItem}>{listItem}</li>
        ))}
      </ul>
    </NoteContainer>
  );
};

export default KindlyNote;

export const NoteContainer = styled.div`
  background: #f7f7f7;
  padding: 0.8rem;
  margin: 4rem auto;
  width: 100%;
  color: #5e5e5e;
  line-height: 24px;
  border-radius: 10px;
  box-sizing: border-box;
`;
